module.exports = __webpack_public_path__ + "static/media/calendar_icon.d4eb85d9.svg";